// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */.top-form{padding:10px 30px 1px 30px}.top-form mat-form-field{margin-right:30px}.top-form mat-form-field.total{margin-right:50px}.top-form.bulk-update-ic-header-fields .mat-form-field.field,.top-form.bulk-update-ic-header-fields .mat-mdc-form-field.field{min-width:145px}.const-center{font-size:14px;margin-left:40px}:host .mat-toolbar,:host .mat-mdc-toolbar{height:70px}`, "",{"version":3,"sources":["webpack://./packages/builder-estimating/price-books/components/price-book-bulk-update-ic/price-book-bulk-update-ic.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAOA,UACE,0BAAA,CACA,yBACE,iBAAA,CACA,+BACE,iBAAA,CAIJ,8HAEE,eAAA,CAGJ,cACE,cAAA,CACA,gBAAA,CAIA,0CAEE,WAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n.top-form {\n  padding: 10px 30px 1px 30px;\n  mat-form-field {\n    margin-right: 30px;\n    &.total {\n      margin-right: 50px;\n    }\n  }\n\n  &.bulk-update-ic-header-fields .mat-form-field.field,\n  &.bulk-update-ic-header-fields .mat-mdc-form-field.field {\n    min-width: 145px;\n  }\n}\n.const-center{\n  font-size: 14px;\n  margin-left: 40px;\n}\n\n:host {\n  .mat-toolbar,\n  .mat-mdc-toolbar {\n    height: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
